export default "__VITE_ASSET__D_GfG628__"